import { FieldsetHTMLAttributes, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';

import Fieldset from '@/components/ui/daisy/fieldset';
import { WithClassname } from '@/components/ui/types';

export const fieldsetBlockClassname =
  'bg-base-100 border-dashed border-secondary flex flex-col gap-6 min-w-0';

type FieldsetContainerProps = PropsWithChildren<WithClassname> &
  FieldsetHTMLAttributes<HTMLFieldSetElement> & {
    block?: boolean;
  };

const FieldsetContainer = ({
  children,
  block,
  className,
  ...rest
}: FieldsetContainerProps) => {
  return (
    <Fieldset
      {...rest}
      className={twMerge(
        'border border-neutral-content p-4 rounded-2xl bg-base-200',
        block && fieldsetBlockClassname,
        className,
      )}
    >
      {children}
    </Fieldset>
  );
};

export default FieldsetContainer;
